import { useQuery } from '@tanstack/react-query'

import { settingsApi } from '../api/settingsApi'

export const useAvatarQuery = () =>
  useQuery({
    queryKey: ['avatar'],
    queryFn: settingsApi.getSaintsAvatar,
  })
